import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import config from 'configs/app';
import { useScrollDirection } from 'lib/contexts/scrollDirection';
import NetworkLogo from 'ui/snippets/networkMenu/NetworkLogo';
import ProfileMenuMobile from 'ui/snippets/profileMenu/ProfileMenuMobile';
import SearchBar from 'ui/snippets/searchBar/SearchBar';
import WalletMenuMobile from 'ui/snippets/walletMenu/WalletMenuMobile';

import Burger from './Burger';

const LOGO_IMAGE_PROPS = {
  margin: '0 auto',
};

type Props = {
  isHomePage?: boolean;
  renderSearchBar?: () => React.ReactNode;
}

const HeaderMobile = ({ isHomePage, renderSearchBar }: Props) => {
  const bgColor = useColorModeValue('white', 'black');
  const scrollDirection = useScrollDirection();
  const [isSticky, setIsSticky] = React.useState<boolean>(false)
  const { ref, inView } = useInView({ threshold: 1 });
  

  React.useEffect(() => {
    const handleScroll = () => {
      const offsetY = window.scrollY;
      if(offsetY > 38) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, []); 
  const searchBar = renderSearchBar ? renderSearchBar() : <SearchBar/>;

  return (
    <Box
      ref={ ref }
      display={{ base: 'block', lg: 'none' }}
      position="sticky"
      top="-1px"
      left={ 0 }
      zIndex="sticky2"
    >
      <Flex
        as="header"
        paddingX={ 4 }
        paddingY={ 2 }
        width="100%"
        // bgColor={isHomePage ? (isSticky ? "#6e2e0a" : "" )  : "#6e2e0a"}
        bgColor={isHomePage ? (isSticky ? "#fff" : "" )  : "#fff"}
        borderBottom={'3px solid #E2E8F0'}

        alignItems="center"
        justifyContent="space-between"
        transitionProperty="box-shadow"
        transitionDuration="slow"
        boxShadow={ !inView && scrollDirection === 'down' ? 'md' : 'none' }
      >
        <Burger/>
        <NetworkLogo imageProps={ LOGO_IMAGE_PROPS }/>
        <Flex columnGap={ 2 }>
          { config.features.account.isEnabled ? <ProfileMenuMobile/> : <Box boxSize={ 10 }/> }
          { config.features.blockchainInteraction.isEnabled && <WalletMenuMobile/> }
        </Flex>
      </Flex>
      { !isHomePage && searchBar }
    </Box>
  );
};

export default React.memo(HeaderMobile);
